export enum GenesysUserStates {
  NOT_AVAILABLE = 'NOT_AVAILABLE',
  AVAILABLE = 'AVAILABLE',
  ON_QUEUE = 'ON_QUEUE',
  BUSY = 'BUSY',
  AWAY = 'AWAY',
  BREAK = 'BREAK',
  MEAL = 'MEAL',
  MEETING = 'MEETING',
  TRAINING = 'TRAINING',
  OUT_OF_OFFICE = 'OUT_OF_OFFICE',
  INCOMING_CALL = 'INCOMING_CALL',
  OUTGOING_CALL = 'OUTGOING_CALL',
}
